/**
 * Renders the visible navigation sections (shared by sidebar + drawer):
 * labelled groups separated by space (a divider only when collapsed, where
 * there are no labels).
 */

import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { NavItemLink } from './NavItemLink';
import { useActiveNavHref } from './useActiveNavHref';
import { useVisibleNav } from './useVisibleNav';

interface NavSectionsProps {
  collapsed?: boolean;
  onNavigate?: () => void;
}

export function NavSections({ collapsed = false, onNavigate }: NavSectionsProps) {
  const { t } = useTranslation('nav');
  const sections = useVisibleNav();
  const activeHref = useActiveNavHref();
  return (
    <>
      {sections.map((section, i) => (
        <div key={section.key} className={cn(i > 0 && (collapsed ? 'mt-3 border-t pt-3' : 'mt-6'))}>
          {section.labelKey && !collapsed ? (
            <p className="mb-2 px-3 text-[0.7rem] font-semibold uppercase tracking-wider text-muted-foreground/80">{t(section.labelKey)}</p>
          ) : null}
          <div className="space-y-1">
            {section.items.map((item) => (
              <NavItemLink key={item.href} item={item} active={item.href === activeHref} collapsed={collapsed} onNavigate={onNavigate} />
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
